export default __webpack_public_path__ + "static/media/circle.9c9a6f94.jpg";